import AuthGuard, { AuthFlow } from '@components/AuthGuard';
import Button from '@components/Button';
import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import colors from '@constants/colors';
import useAppCustom from '@hooks/useAppCustom';
import FavoriteCircleLine from '@icons/favorite/FavoriteCircleLine';
import { ItemResponse } from '@models/item';
import { Link } from '@router/Link';
import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';
import useItemQuantity from '@store/item/hooks/useItemQuantity';
import { itemActions } from '@store/item/itemSlice';
import { useDispatch } from 'react-redux';

import useAddCart from './hooks/useAddCart';
import OptionSelectionGuard from './OptionSelectionGuard';
import styles from './styles.module.scss';

interface Props {
    shopId: string;
    isSoldOut: boolean;
    item: ItemResponse;
}

function OrderFooter({ item, shopId, isSoldOut }:Props) {
  const itemId = item.id;
  const { handleAddToCart } = useAddCart(shopId);
  const { itemMaxQuantity } = useAppCustom().item;
  const authFlows: AuthFlow[] = [
    { activityName: 'ShopListActivity', activityParams: { isOrder: false, type: 'LIST' } },
    { activityName: 'ItemsActivity', activityParams: { shopId, type: 'ALL' } },
    { activityName: 'ItemActivity', activityParams: { itemId, shopId } },
  ];
  const { totalAmount } = useCalculatedOrder();
  const dispatch = useDispatch();
  const itemQuantity = useItemQuantity(itemId);
  return (
        <footer className={styles.container}>
            <Row className={styles.price}
                 justify='space-between'>
                <div className={styles.stepper}>
                    <Stepper value={itemQuantity}
                             max={itemMaxQuantity}
                             min={1}
                             increase={() => dispatch(itemActions.updateItemQuantity({
                               itemId, amount: 1,
                             }))}
                             decrease={() => dispatch(itemActions.updateItemQuantity({
                               itemId, amount: -1,
                             }))} />
                </div>
                <Text size='3xl' fontWeight='bold' color={colors.red}>
                    {totalAmount.toLocaleString()}원
                </Text>
            </Row>
            <Row spacing={16} className={styles.containers}>
                {/*
                <AuthGuard flows={authFlows}
                           className={styles.myMenu} >
                    <Column align='center' spacing={8}>
                        <FavoriteCircleLine color={colors.primary} size={30}/>
                        <Text color={colors.gray7} fontWeight='bold'>
                            MY메뉴
                        </Text>
                    </Column>
                </AuthGuard>
                */}
                <Row fullWidth spacing={8}>
                    <AuthGuard flows={authFlows}>
                        <OptionSelectionGuard item={item}>
                            <Button fullWidth variant='secondary'
                                    onClick={handleAddToCart} >
                                담기
                            </Button>
                        </OptionSelectionGuard>
                    </AuthGuard>
                    <AuthGuard flows={authFlows}>
                        <OptionSelectionGuard item={item}>
                            <Link activityName='OrderActivity'
                                  activityParams={{ path: 'direct' }}
                                  className={styles.purchase} >
                                <Button fullWidth
                                        disabled={isSoldOut} >
                                    {isSoldOut ? '품절' : '바로 주문'}
                                </Button>
                            </Link>
                        </OptionSelectionGuard>
                    </AuthGuard>
                </Row>
            </Row>
        </footer>
  );
}

export default OrderFooter;
